




































import { Vue, Prop, Component } from 'vue-property-decorator'
import videojs from 'video.js'
import vueSlider from 'vue-slider-component'
@Component({
  components: {
    vueSlider
  }
})
export default class AudioM3u8Modal extends Vue {
  @Prop() lessonDetail
  @Prop() hasAccess
  @Prop() finishRate
  video: any = ''
  playing: boolean = false
  videoCanPlay: boolean = true
  hasAccount: boolean = false
  hasAccountFinish: boolean = false
  currentTime: any = 0
  totalDuration: any = Date.formatMs(this.lessonDetail.duration * 1000, "mm:ss")
  durationFormate: any = "00:00"
  slider = { // 控制进度条部分
    curValue: 0,
    height: 4,
    dotWidth: 15,
    dotHeight: 15,
    bgStyle: {
      backgroundColor: "#e6e6e6",
      height: "0.12rem"
    },
    processStyle: {
      backgroundColor: "#ffb450"
    },
    sliderStyle: {
      backgroundColor: "#ffb450",
      boxShadow: "none"
    }
  }
  mounted() {
    if (!this.hasAccess) return this.showPrompt('sale')
    this.video = videojs('video2', {
      playbackRates: [0.5, 1, 1.5, 2]
    })
    this.video.on("ended", e => {
      this.playing = false
      this.video.exitFullscreen()
      this.$emit("togglePlay", 1, true)
    })
    this.video.on("pause", e => {
      this.playing = false
    })
    this.video.on("play", e => {
      this.playing = true
      this.videoCanPlay = true
      if (!this.hasAccount) {
        this.hasAccount = true
        this.$emit('addPlayCount')
      }
    })
    this.video.on("timeupdate", e => {
      let duration = this.video.duration()
      let currentTime = this.video.currentTime()
      if (!this.videoCanPlay && currentTime > 0) {
        this.videoCanPlay = true
      }
      this.durationFormate = Date.formatMs(currentTime * 1000, "mm:ss")
      this.currentTime = e.target.currentTime
      this.slider.curValue = parseInt(`${(currentTime / duration) * 100}`, 10)
      if (e.target.currentTime / e.target.duration >= +this.finishRate && !this.hasAccountFinish) {
        this.hasAccountFinish = true
        this.$emit("accountPlayFinish")
      }
      if (e.target.currentTime >= e.target.duration) {
        this.durationFormate = "00:00"
        this.slider.curValue = 0
        this.playing = false
        this.currentTime = 0
        // 播放完毕
        this.showPrompt()
      }
    })
    this.video.on("canplaythrough", e => {
      this.videoCanPlay = true
      this.playVideo()
    })
  }
  async showPrompt(type = 'end') {
    this.$emit('showBuyPrompt', type)
  }
  playVideo() {
    if (!this.hasAccess) return this.showPrompt('sale')
    this.videoCanPlay = false
    this.playing = true
    this.$emit('playDurationPoint', 'play')
    this.video.play()
  }
  pauseVideo() {
    this.playing = false
    this.$emit('playDurationPoint', 'pause')
    this.video.pause()
  }
  changeSlider(event) {
    if (!this.hasAccess) {
      return this.showPrompt()
    }
    let pos = parseInt(`${this.lessonDetail.duration / (100 / event)}`, 10)
    this.playing = true
    this.video.currentTime(pos)
  }
  destroyed() {
    this.video && this.video.dispose()
  }
}
